module.exports = __webpack_public_path__ + "static/media/6.46dc8acf.png";